import { useUser, useSupabaseClient } from "@supabase/auth-helpers-react";
import { useState, useEffect } from "react";
import { ThemeToggle } from "@/components/ThemeToggle";
import { motion } from "framer-motion";
import { HeaderTitle } from "./header/HeaderTitle";
import { AdminButton } from "./header/AdminButton";
import { LogoutButton } from "./header/LogoutButton";
import { LoginButton } from "./header/LoginButton";

export const Header = () => {
  const user = useUser();
  const supabase = useSupabaseClient();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkUserRole = async () => {
      if (!user) return;
      
      try {
        const { data: userRole, error } = await supabase
          .from('user_roles')
          .select('role')
          .eq('user_id', user.id)
          .single();

        if (error) throw error;
        
        setIsAdmin(userRole?.role === 'admin' || userRole?.role === 'moderator');
      } catch (error) {
        console.error('Error checking user role:', error);
      }
    };

    checkUserRole();
  }, [user, supabase]);

  return (
    <motion.div 
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="relative flex justify-between items-center mb-8 p-4 rounded-xl bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm shadow-sm hover:shadow-md transition-all duration-300"
    >
      <HeaderTitle />
      <div className="flex items-center gap-2">
        <ThemeToggle />
        {user ? (
          <div className="flex items-center gap-2">
            {isAdmin && <AdminButton />}
            <LogoutButton />
          </div>
        ) : (
          <LoginButton />
        )}
      </div>
    </motion.div>
  );
};